import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const CategoryPage = lazy(() => import('../pages/category/page'));
const ComboPage = lazy(() => import('../pages/combo/page'));
const ProductPage = lazy(() => import('../pages/product/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const BlogDetailPage = lazy(() => import('../pages/blog/detail/page'));
const IndirimlerPage = lazy(() => import('../pages/indirimler/page'));
const SuperSalePage = lazy(() => import('../pages/super-sale/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const LoginPage = lazy(() => import('../pages/login/page'));
const RegisterPage = lazy(() => import('../pages/register/page'));
const CheckoutPage = lazy(() => import('../pages/checkout/page'));
const SurdurulebilirlikPage = lazy(() => import('../pages/surdurulebilirlik/page'));
const YorumlarPage = lazy(() => import('../pages/yorumlar/page'));
const PopulerUrunlerPage = lazy(() => import('../pages/populer-urunler/page'));
const VideolarPage = lazy(() => import('../pages/videolar/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const OzelliklerPage = lazy(() => import('../pages/ozellikler/page'));
const CanliDestekPage = lazy(() => import('../pages/canlidestek/page'));
const AboutUsPage = lazy(() => import('../pages/about-us/page'));
const TermsConditionsPage = lazy(() => import('../pages/terms-conditions/page'));
const PrivacyPolicyPage = lazy(() => import('../pages/privacy-policy/page'));
const ReturnsExchangesPage = lazy(() => import('../pages/returns-exchanges/page'));
const DeliveryShippingPage = lazy(() => import('../pages/delivery-shipping/page'));
const FaqPage = lazy(() => import('../pages/faq/page'));
const ReturnsPage = lazy(() => import('../pages/returns/page'));
const ShippingPage = lazy(() => import('../pages/shipping/page'));
const FavoritesPage = lazy(() => import('../pages/favorites/page'));
const SitemapPage = lazy(() => import('../pages/sitemap/page'));
const ToptanPage = lazy(() => import('../pages/toptan/page'));
const HesabimPage = lazy(() => import('../pages/hesabim/page'));
const SearchPage = lazy(() => import('../pages/search/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },

  // ── Kadın Ana Kategori ──
  {
    path: '/women',
    element: <CategoryPage />,
  },
  // Kadın Alt Kategoriler
  {
    path: '/women/clothing',
    element: <CategoryPage />,
  },
  // Kadın Giyim Alt Kategorileri
  {
    path: '/women/clothing/tshirt',
    element: <CategoryPage />,
  },
  {
    path: '/women/clothing/pants',
    element: <CategoryPage />,
  },
  {
    path: '/women/clothing/dress',
    element: <CategoryPage />,
  },
  {
    path: '/women/clothing/kimono',
    element: <CategoryPage />,
  },
  {
    path: '/women/clothing/crop',
    element: <CategoryPage />,
  },
  {
    path: '/women/clothing/shirt',
    element: <CategoryPage />,
  },
  {
    path: '/women/clothing/skirt',
    element: <CategoryPage />,
  },
  {
    path: '/women/clothing/shorts',
    element: <CategoryPage />,
  },
  {
    path: '/women/clothing/suit',
    element: <CategoryPage />,
  },
  {
    path: '/women/clothing/set',
    element: <CategoryPage />,
  },
  {
    path: '/women/sandals',
    element: <CategoryPage />,
  },
  {
    path: '/women/slippers',
    element: <CategoryPage />,
  },
  {
    path: '/women/shoes',
    element: <CategoryPage />,
  },
  {
    path: '/women/bags',
    element: <CategoryPage />,
  },
  {
    path: '/women/accessories',
    element: <CategoryPage />,
  },
  {
    path: '/women/boots',
    element: <CategoryPage />,
  },
  {
    path: '/women/combo',
    element: <ComboPage />,
  },

  // ── Erkek Ana Kategori ──
  {
    path: '/men',
    element: <CategoryPage />,
  },
  // Erkek Alt Kategoriler
  {
    path: '/men/clothing',
    element: <CategoryPage />,
  },
  // Erkek Giyim Alt Kategorileri
  {
    path: '/men/clothing/tshirt',
    element: <CategoryPage />,
  },
  {
    path: '/men/clothing/pants',
    element: <CategoryPage />,
  },
  {
    path: '/men/clothing/shirt',
    element: <CategoryPage />,
  },
  {
    path: '/men/clothing/shorts',
    element: <CategoryPage />,
  },
  {
    path: '/men/clothing/suit',
    element: <CategoryPage />,
  },
  {
    path: '/men/sandals',
    element: <CategoryPage />,
  },
  {
    path: '/men/slippers',
    element: <CategoryPage />,
  },
  {
    path: '/men/shoes',
    element: <CategoryPage />,
  },
  {
    path: '/men/bags',
    element: <CategoryPage />,
  },
  {
    path: '/men/accessories',
    element: <CategoryPage />,
  },
  {
    path: '/men/boots',
    element: <CategoryPage />,
  },
  {
    path: '/men/combo',
    element: <ComboPage />,
  },

  // ── Özel Kategoriler ──
  {
    path: '/combo',
    element: <ComboPage />,
  },
  {
    path: '/vegan-leather',
    element: <CategoryPage />,
  },
  {
    path: '/genuine-leather',
    element: <CategoryPage />,
  },

  // ── Eski URL'ler (geriye dönük uyumluluk) ──
  {
    path: '/category/combo',
    element: <ComboPage />,
  },
  {
    path: '/category/women-combo',
    element: <ComboPage />,
  },
  {
    path: '/category/men-combo',
    element: <ComboPage />,
  },
  {
    path: '/category/:categoryId',
    element: <CategoryPage />,
  },

  // ── SEO-Friendly Product URLs: /:category/urun-adi ──
  // 4-segment: /women/clothing/:subCat/:productSlug
  {
    path: '/women/clothing/:subCat/:productSlug',
    element: <ProductPage />,
  },
  {
    path: '/men/clothing/:subCat/:productSlug',
    element: <ProductPage />,
  },
  // 3-segment: /women/:subCat/:productSlug  (sandals, shoes, boots, etc.)
  {
    path: '/women/:subCat/:productSlug',
    element: <ProductPage />,
  },
  {
    path: '/men/:subCat/:productSlug',
    element: <ProductPage />,
  },
  // 2-segment: /combo/:productSlug  /vegan-leather/:slug  /genuine-leather/:slug
  {
    path: '/combo/:productSlug',
    element: <ProductPage />,
  },
  {
    path: '/vegan-leather/:productSlug',
    element: <ProductPage />,
  },
  {
    path: '/genuine-leather/:productSlug',
    element: <ProductPage />,
  },

  {
    path: '/product/:id',
    element: <ProductPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/:slug',
    element: <BlogDetailPage />,
  },
  {
    path: '/indirimler',
    element: <IndirimlerPage />,
  },
  {
    path: '/super-sale',
    element: <SuperSalePage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/register',
    element: <RegisterPage />,
  },
  {
    path: '/checkout',
    element: <CheckoutPage />,
  },
  {
    path: '/surdurulebilirlik',
    element: <SurdurulebilirlikPage />,
  },
  {
    path: '/yorumlar',
    element: <YorumlarPage />,
  },
  {
    path: '/populer-urunler',
    element: <PopulerUrunlerPage />,
  },
  {
    path: '/videolar',
    element: <VideolarPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/ozellikler',
    element: <OzelliklerPage />,
  },
  {
    path: '/canlidestek',
    element: <CanliDestekPage />,
  },
  {
    path: '/about-us',
    element: <AboutUsPage />,
  },
  {
    path: '/terms-conditions',
    element: <TermsConditionsPage />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicyPage />,
  },
  {
    path: '/returns-exchanges',
    element: <ReturnsExchangesPage />,
  },
  {
    path: '/delivery-shipping',
    element: <DeliveryShippingPage />,
  },
  {
    path: '/faq',
    element: <FaqPage />,
  },
  {
    path: '/returns',
    element: <ReturnsPage />,
  },
  {
    path: '/shipping',
    element: <ShippingPage />,
  },
  {
    path: '/favorites',
    element: <FavoritesPage />,
  },
  {
    path: '/sitemap',
    element: <SitemapPage />,
  },
  {
    path: '/toptan',
    element: <ToptanPage />,
  },
  {
    path: '/hesabim',
    element: <HesabimPage />,
  },
  {
    path: '/search',
    element: <SearchPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
